export default "__VITE_ASSET__891da901__"